import { URLS } from '@/lib/consts';

export const REMODELS_TITLE = 'Remodels';

export const REMODELS_DESCRIPTION =
  'Every remodel completed by Cornerstone is rendered in 3D before construction begins. We believe that when homeowners can clearly see and believe in the vision, it leads to the most cohesive and satisfying results.';

export const REMODELS = [
  {
    title: 'Kitchens',
    uri: `${URLS.SERVICES.DESIGN_AND_RENOVATE}/kitchen`,
  },
  {
    title: 'Bathrooms',
    uri: `${URLS.SERVICES.DESIGN_AND_RENOVATE}/bathroom`,
  },
  {
    title: 'Additions',
    uri: `${URLS.SERVICES.DESIGN_AND_RENOVATE}/addition`,
  },
] as const;
